import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-left flex flex-col sm:gap-8 gap-4" }
const _hoisted_2 = { class: "block text-sm font-medium leading-6 text-gray-900" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = { class: "block truncate text-xs" }
const _hoisted_5 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "text-xs mt-1 text-red-600 sm:col-span-2 sm:items-end sm:col-start-2"
}
const _hoisted_8 = { class: "flex flex-col gap-2" }
const _hoisted_9 = { class: "text-sm font-medium leading-6 text-gray-900 flex items-center gap-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Use setting", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "pointer-events-none absolute h-full w-full rounded-md bg-white"
}, null, -1)
const _hoisted_12 = {
  key: 2,
  class: "flex items-center gap-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Use settings", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "pointer-events-none absolute h-full w-full rounded-md bg-white"
}, null, -1)
const _hoisted_15 = {
  type: "submit",
  class: "focus:outline-none flex w-full justify-center rounded-md border border-transparent bg-yellow-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-yellow-600 focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
}

import { Listbox, ListboxButton, ListboxOption, ListboxOptions, Switch } from "@headlessui/vue";
import { ChevronUpDownIcon, CheckIcon } from "@heroicons/vue/24/solid";
import { Form, SubmissionHandler } from "vee-validate";
import { computed, PropType } from "vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import * as yup from "yup";
import DateField from "@/components/forms/DateField.vue";
import Field from "@/components/forms/Field.vue";
import ModalTW from "@/components/modals/ModalTW.vue";
import CustomOptionsCombobox from "@/components/other/CustomOptionsCombobox.vue";
import { disturbances } from "@/constants/disturbances";
import { NonWorkingDay } from "@/types/ProjectDurationSettings";


export default /*#__PURE__*/_defineComponent({
  __name: 'NonWorkingDaysEditor',
  props: {
  nonWorkingDay: {
    type: Object as PropType<NonWorkingDay>,
    required: false,
  },
},
  emits: ["commit", "close"],
  setup(__props, { emit: __emit }) {

const { t, te } = useI18n();
const hasSubmitted = ref(false);

const props = __props;

const schema = computed(() =>
  yup.object({
    name: yup.string().required(t("admin.durations_project_settings.validation_name_empty")),
    start_date: yup
      .date()
      .nullable()
      .test(
        "is-required-has-end",
        t("admin.durations_project_settings.validation_start_required"),
        function () {
          return (this.parent.has_end_date && this.originalValue) || !this.parent.has_end_date;
        },
      )
      .test(
        "is-required-has-no-end",
        t("admin.durations_project_settings.validation_date_required"),
        function () {
          return (!this.parent.has_end_date && this.originalValue) || this.parent.has_end_date;
        },
      )
      .test(
        "is-before-end",
        t("admin.durations_project_settings.validation_start_more_than_end"),
        function () {
          return (
            !this.parent.end_date ||
            !this.parent.has_end_date ||
            this.originalValue < this.parent.end_date
          );
        },
      ),
    end_date: yup
      .date()
      .nullable()
      .test(
        "is-required",
        t("admin.durations_project_settings.validation_end_required"),
        function () {
          return (this.parent.has_end_date && this.originalValue) || !this.parent.has_end_date;
        },
      ),
    type: yup.string().required(),
    disturbance_type: yup.string().when("type", {
      is: "disturbance",
      then: (schema) =>
        schema.required(t("admin.durations_project_settings.validation_disturbance_type_empty")),
    }),
    is_critical: yup.boolean().required(),
    disturbance_description: yup.string().nullable().default(null),
  }),
);

const initialValues = computed(() => {
  if (props.nonWorkingDay) {
    return {
      ...props.nonWorkingDay,
      has_end_date:
        !!props.nonWorkingDay.end_date &&
        props.nonWorkingDay.start_date.getTime() !== props.nonWorkingDay.end_date.getTime(),
    };
  }
  return { type: "public_holiday", is_critical: false };
});

const emit = __emit;

const handleSubmit: SubmissionHandler = (genericObject) => {
  const { has_end_date, is_critical, disturbance_type, disturbance_description, ...rest } =
    genericObject;
  const holiday = {
    ...rest,
    is_critical: rest.type !== "disturbance" ? true : is_critical,
    end_date: has_end_date ? rest.end_date : rest.start_date,
    disturbance_type: disturbance_type || null,
    disturbance_description: disturbance_description || null,
  };

  emit("commit", holiday);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalTW, {
    open: true,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close'))),
    customCls: "w-full sm:w-1/4"
  }, {
    content: _withCtx(() => [
      _createVNode(_unref(Form), {
        onSubmit: handleSubmit,
        onInvalidSubmit: _cache[0] || (_cache[0] = ($event: any) => (hasSubmitted.value = true)),
        initialValues: initialValues.value,
        validationSchema: schema.value
      }, {
        default: _withCtx(({ values, setFieldValue, errors }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Field, {
              name: "name",
              label: _unref(t)('admin.durations_project_settings.holidays_field_name')
            }, null, 8, ["label"]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_2, _toDisplayString(_unref(t)("admin.durations_project_settings.holidays_field_type")), 1),
              _createVNode(_unref(Listbox), {
                as: "div",
                modelValue: values.type,
                "onUpdate:modelValue": ($event: any) => (setFieldValue('type', $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(ListboxButton), {
                      class: "relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-600 sm:text-sm sm:leading-6",
                      style: {"min-height":"36px"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(
                      `admin.durations_project_settings.non_working_day_type_labels.${values.type}`,
                    )), 1),
                        _createElementVNode("span", _hoisted_5, [
                          _createVNode(_unref(ChevronUpDownIcon), { class: "h-5 w-5 text-gray-400" })
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_Transition, {
                      "leave-active-class": "transition ease-in duration-100",
                      "leave-from-class": "opacity-100",
                      "leave-to-class": "opacity-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ListboxOptions), { class: "absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm" }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['public_holiday', 'company_holiday', 'disturbance'], (item) => {
                              return _createVNode(_unref(ListboxOption), {
                                as: "template",
                                key: item,
                                value: item
                              }, {
                                default: _withCtx(({ active, selected }) => [
                                  _createElementVNode("li", {
                                    class: _normalizeClass([
                          active ? 'bg-yellow-600 text-white' : 'text-gray-900',
                          'relative cursor-default select-none py-2 pl-3 pr-9',
                        ])
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["text-xs", [selected ? 'font-semibold' : 'font-normal', 'block truncate']])
                                    }, _toDisplayString(_ctx.$t(
                              `admin.durations_project_settings.non_working_day_type_labels.${item}`,
                            )), 3),
                                    selected
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: _normalizeClass([
                            active ? 'text-white' : 'text-yellow-600',
                            'absolute inset-y-0 right-0 flex items-center pr-4',
                          ])
                                        }, [
                                          _createVNode(_unref(CheckIcon), {
                                            class: "h-5 w-5",
                                            "aria-hidden": "true"
                                          })
                                        ], 2))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ]),
                                _: 2
                              }, 1032, ["value"])
                            }), 64))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])
            ]),
            (values.type === 'disturbance')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(CustomOptionsCombobox, {
                    label: _unref(t)('admin.durations_project_settings.holidays_field_disturbance_type'),
                    options: 
                _unref(disturbances).map((disturbance) => ({
                  name: _unref(te)(`admin.durations_project_settings.disturbances.${disturbance}`)
                    ? _unref(t)(`admin.durations_project_settings.disturbances.${disturbance}`)
                    : disturbance,
                  value: disturbance,
                }))
              ,
                    selected: values.disturbance_type,
                    onUpdate: ($event: any) => (setFieldValue('disturbance_type', $event.value))
                  }, null, 8, ["label", "options", "selected", "onUpdate"]),
                  (hasSubmitted.value && errors.disturbance_type)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(errors.disturbance_type), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (values.type === 'disturbance')
              ? (_openBlock(), _createBlock(Field, {
                  key: 1,
                  as: "textarea",
                  name: "disturbance_description",
                  inputClass: "max-h-24",
                  label: _unref(t)('admin.durations_project_settings.holidays_field_disturbance_description')
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(DateField, {
              name: "start_date",
              label: 
              values.has_end_date
                ? _unref(t)('admin.durations_project_settings.holidays_field_start')
                : _unref(t)('admin.durations_project_settings.holidays_field_date')
            
            }, null, 8, ["label"]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(_unref(t)("admin.durations_project_settings.holidays_field_end")) + " ", 1),
                _createVNode(_unref(Switch), {
                  modelValue: values.has_end_date,
                  "onUpdate:modelValue": ($event: any) => (setFieldValue('has_end_date', $event)),
                  class: "group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _hoisted_11,
                    _createElementVNode("span", {
                      "aria-hidden": "true",
                      class: _normalizeClass([
                    values.has_end_date ? 'bg-yellow-500' : 'bg-gray-200',
                    'pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out',
                  ])
                    }, null, 2),
                    _createElementVNode("span", {
                      "aria-hidden": "true",
                      class: _normalizeClass([
                    values.has_end_date ? 'translate-x-5' : 'translate-x-0',
                    'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out',
                  ])
                    }, null, 2)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ]),
              (values.has_end_date)
                ? (_openBlock(), _createBlock(DateField, {
                    key: 0,
                    name: "end_date"
                  }))
                : _createCommentVNode("", true)
            ]),
            (values.type === 'disturbance')
              ? (_openBlock(), _createElementBlock("label", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_unref(t)("admin.durations_project_settings.holidays_field_critical")) + " ", 1),
                  _createVNode(_unref(Switch), {
                    modelValue: values.is_critical,
                    "onUpdate:modelValue": ($event: any) => (setFieldValue('is_critical', $event)),
                    class: "group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none mr-2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _hoisted_14,
                      _createElementVNode("span", {
                        "aria-hidden": "true",
                        class: _normalizeClass([
                  values.is_critical ? 'bg-yellow-500' : 'bg-gray-200',
                  'pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out',
                ])
                      }, null, 2),
                      _createElementVNode("span", {
                        "aria-hidden": "true",
                        class: _normalizeClass([
                  values.is_critical ? 'translate-x-5' : 'translate-x-0',
                  'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out',
                ])
                      }, null, 2)
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", _hoisted_15, _toDisplayString(_unref(t)("buttons.apply")), 1)
          ])
        ]),
        _: 1
      }, 8, ["initialValues", "validationSchema"])
    ]),
    _: 1
  }))
}
}

})